import { isEmpty } from "lodash";
import queryString from "query-string";

// eslint-disable-next-line
export default function cmsUrl({ cms, endpoint = "", params = {} }) {
  return `${cms.url}${endpoint}${
    isEmpty(params) ? "" : `?${queryString.stringify(params)}`
  }`;
}
